export default __webpack_public_path__ + "static/media/right.82452e13.png";